import {
    mapActions,
    mapGetters,
    mapState
} from 'vuex';
import debounce from 'lodash/debounce';
export const odbMixins = {
    data() {
        return {

            params: {
                query: {
                    $limit: 100,
                    $sort: {
                        code: 1
                    }
                }
            },
        }
    },
    computed: {
        ...mapState('odb', {
            cdbLoading: 'isFindPending'
        }),
        ...mapGetters('odb', {
            findCdbInStore: 'find',
            getCdb: 'get'
        }),

        odb() {
            return this.findCdbInStore(this.params).data;
        },
    },
    watch: {
        query: debounce(function (newVal) {
            this.queryItems();
        }, 400),
        parentId: debounce(function (newVal) {
            this.queryItems();

        }, 400),
    },
    methods: {
        ...mapActions('odb', ['find', 'get']),


        queryItems() {
            if (this.query) {
                this.params.query.$or = [{
                        label: {
                            $regex: this.query,
                            $options: "i"
                        }
                    },
                    {
                        code: {
                            $regex: this.query,
                            $options: "i"
                        }
                    },
                    {
                        description: {
                            $regex: this.query,
                            $options: "i"
                        }
                    },
                ];
            } else {
                delete this.params.query.$or;
            }

            if (this.parentId) {
                this.params.query.parentId = this.parentId;
            } else {
                this.params.query.parentId = null;
                if (this.query) {
                    delete this.params.query.parentId;
                }
            }


            this.find(this.params).then(data => {
                this.breadcrumbs = [];
                this.getParents(this.parentId);
            });

        },
    }

}
